'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dList from "./java.util.-Collections$-Unmodifiable-List.js";
var $p;
/** @constructor */
function $c_ju_Collections$ImmutableList(inner) {
  this.fv = null;
  $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dList.$ct_ju_Collections$UnmodifiableList__ju_List__(this, inner);
}
export { $c_ju_Collections$ImmutableList as $c_ju_Collections$ImmutableList };
$p = $c_ju_Collections$ImmutableList.prototype = new $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dList.$h_ju_Collections$UnmodifiableList();
$p.constructor = $c_ju_Collections$ImmutableList;
/** @constructor */
function $h_ju_Collections$ImmutableList() {
}
export { $h_ju_Collections$ImmutableList as $h_ju_Collections$ImmutableList };
$h_ju_Collections$ImmutableList.prototype = $p;
var $d_ju_Collections$ImmutableList = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Collections$ImmutableList, "java.util.Collections$ImmutableList", ({
  mV: 1,
  mX: 1,
  mW: 1,
  mZ: 1,
  aU: 1,
  bc: 1,
  a: 1,
  n1: 1,
  n0: 1,
  bu: 1,
  ck: 1
}));
export { $d_ju_Collections$ImmutableList as $d_ju_Collections$ImmutableList };
